import React from 'react';
import { getNewQuoteRows } from 'src/pages/OfferPage/DocuBom/quoteBomPortalUtils';
import {
  calculateLabourCost,
  getBomColumns,
  getBomRows,
  getNewBomColumns
} from 'src/pages/OfferPage/DocuBom/DocuBomUtils';
import { ts } from 'src/utils/translate';
import { BomTable } from 'src/pages/OfferPage/DocuBom/BomTable';
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';
import { GetQuoteResponse } from 'src/model/api/quote/get-quote-response.model';

export const DocuBom = (
    {
      workHourPrices,
      quoteResponse,
      tableData,
      currency,
      currencyVisibility,
      bomEnabled,
      quoteUserProperties
    }: {
      workHourPrices: any
      quoteResponse: GetQuoteResponse
      tableData: any
      currency: string
      currencyVisibility: number
      bomEnabled: boolean
      quoteUserProperties: ProjectQuoteUserProperties
    }
) => {

  let quoteColumnsCopy = JSON.parse(JSON.stringify(quoteResponse["quote-project-custom-section"].columns));
  let columns = getBomColumns(quoteColumnsCopy);
  let newColumns = getNewBomColumns(columns, currencyVisibility, currency, quoteUserProperties);
  const rows: any = getBomRows(tableData, quoteUserProperties);

  let labourCost = calculateLabourCost(rows, currency, workHourPrices, quoteResponse.icon_work_minutes);
  const installationRow = rows.services.find((row: any) => row.specification_type === "installation");
  const personalisationRow = rows.services.find((row: any) => row.specification_type === "personalisation");

  if (installationRow) {
    installationRow[`price_${currency}`] = labourCost.installation.hourlyRate;
    installationRow.quantity = labourCost.installation.hours;
  }

  if(personalisationRow) {
    personalisationRow[`price_${currency}`] = labourCost.personalisation.hourlyRate;
    personalisationRow.quantity = labourCost.personalisation.hours;
  }

  let newRows =  getNewQuoteRows(rows, quoteUserProperties.include_labour_cost === 1);

  // Finally we group sockets by article number
  // because the same product has different name in the planner (Socket, Dishwasher, Oven, etc.)
  // and we want these to be shown as one product.
  // The same operation is applied at the end of QuoteController->getBomDataHelper() method
  const atricleNumbersToGroup = ['100-66601', '101-66601', '102-66601', '121-66601', '122-66601', '123-66601', '124-66601', '154-66601', '157-66601', '161-66601', '200-66601', '220-66601', '221-66601', '4188005', '418803', '418826', '418827', '418828', '4188600', '418865', '418866', '418867', '753121', '753221', '753321', 'MTN2301-0319'];
  const newRowsGrouped: any = {};

  if (newRows && newRows.length) {
    newRows.forEach(row => {
      if (atricleNumbersToGroup.includes(row.article_number)) {
        var key = row.article_number + row.color_name;
        if (newRowsGrouped[key]) {
          newRowsGrouped[key].quantity += row.quantity;
        } else {
          newRowsGrouped[key] = {...row}
          newRowsGrouped[key].product_name = [row.category_name, row.manufacturer_name, row.color_name].join(' ');
        }
      } else {
        newRowsGrouped[row.rowKey] = {...row}
      }
    });
    newRows = Object.values(newRowsGrouped);
  }

  return bomEnabled &&
    newRows &&
    newRows.length &&
    newColumns &&
    newColumns.length ? (
    <div id="react-quote-bom">
      <div className="room-header-container">
        <h3
          style={{
            fontWeight: 300,
            lineHeight: "24px",
          }}
        >
          {ts("bom", "Bill of Materials")}
        </h3>
      </div>
      <BomTable newColumns={newColumns} newRows={newRows} />
    </div>
  ) : null;
};
